import getApiService from 'modules/api/services/get'
import { getApiServiceUrlEnvironmentUtil } from 'modules/environment/utils'

function loadReduxApi (params) {
  let {
    endpoint,
    remoteUrl,
    options
  } = params
  remoteUrl = remoteUrl || getApiServiceUrlEnvironmentUtil()
  const url = `${remoteUrl}${endpoint}`
  return getApiService(url, options)
    .then(response => Object.values(response.data)[0])
}

export default loadReduxApi
